<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ff4081" type="timer" [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner>

<div class="mat-app-background" [ngClass]="className">
  <mat-toolbar color="primary" class="header-toolbar">
    <div class="container">
      <div class="logo-container">
        <img src="../../assets/honeywell_logo.png" class="main-logo" />
        <span class="divider"> | </span>
        <div class="home-logo">
          <mat-icon aria-hidden="false" class="home-icon" (click)="goHome();" matTooltip="Home" aria-label="home icon"
            [inline]="true">
            home
          </mat-icon>
          <span class="environment-label" (click)="goHome();">{{ environmentType }}</span>
        </div>
      </div>
      <div *ngIf="defaultUtility" class="utilSelector">
        <mat-form-field class="util-input-section">
          <mat-select [(value)]="defaultUtility" [disabled]="disableSelect"
            (selectionChange)="utilityUpdated(defaultUtility)">
            <mat-option class="mat-input-select" *ngFor="let util of utilList" [value]="util">
              {{ util.ProgramsponsorDescription }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="profile-section">
        <button class="theam-section" mat-button matTooltip="Branding" [matMenuTriggerFor]="themeMenu">
          <mat-icon [inline]="true">invert_colors</mat-icon>
        </button>

        <mat-menu #themeMenu="matMenu" class="theme-menu">
          <button *ngFor="let theme of themes" mat-menu-item class="theme-menu-item" [style.background]="theme.color"
            (click)="changeTheme(theme.name, theme.color)">
          </button>
        </mat-menu>

        <mat-icon class="person-pin" matTooltip="Person Pin" aria-hidden="false" aria-label="Example home icon"
          [inline]="true">
          person_pin
        </mat-icon>
        <span class="profile-name">{{loggedInUserName}}</span>
      </div>
    </div>
  </mat-toolbar>
  <mat-drawer-container class="flex" color="primary" [autosize]="false">
    <mat-drawer mode="side" opened class="sidenav-container" (mouseenter)="matSelectClick(null)">
      <div class="table-header-color" style="overflow: hidden; position: relative; top: 8%;">

        <ng-container *ngIf="resourceRole != 'contractor' && resourceRole != 'distributor' 
          && this.userRole != 'CLIENT' && this.userRole != 'UTILRO'">
          <button mat-button (mouseenter)="matSelectClick('first')" matTooltip="Access Time"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw;width: 100% !important;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all; 
            font-size: 2vw;" aria-hidden="false" aria-label="launch icon" [inline]="true">
              access_time
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">arrow_right</mat-icon>
            <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="lastVisited"></div>
          </button>
          <mat-menu #lastVisited="matMenu" [hasBackdrop]="false">
            <span *ngIf="storedCustomers.length > 0" (mouseleave)="menuTrigger.closeMenu()">
              <button mat-menu-item style="font-size: 0.8vw;" *ngFor="let customer of storedCustomers"
                (click)="goToCustomerDetails(customer);"> {{customer.Name | uppercase}}</button>
            </span>
            <span *ngIf="storedCustomers.length == 0" (mouseleave)="menuTrigger.closeMenu()">
              No recent items
            </span>
          </mat-menu>
        </ng-container>

        <ng-container *ngIf="resourceRole != 'contractor' && resourceRole != 'distributor' 
          && this.userRole != 'CLIENT' && this.userRole != 'UTILRO'">
          <button mat-button (mouseenter)="matSelectClick('second')" matTooltip="Supervisor Account"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw;width: 100% !important;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all;font-size: 2vw;" aria-hidden="false"
              aria-label="launch icon" [inline]="true">
              supervisor_account
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">arrow_right</mat-icon>
            <div #menuTrigger1="matMenuTrigger" [matMenuTriggerFor]="admin"></div>
          </button>

          <mat-menu #admin="matMenu" [hasBackdrop]="false">
            <span (mouseleave)="menuTrigger1.closeMenu()">
              <button mat-menu-item style="font-size: 0.8vw;" *ngFor="let listitem of adminViewList"
                (click)="Navigate(listitem.rl,false);"> {{listitem.name | uppercase}}</button>
            </span>
          </mat-menu>
        </ng-container>

        <ng-container *ngIf="resourceRole != 'contractor' && resourceRole != 'distributor'">
          <button mat-button (mouseenter)="matSelectClick('third')" matTooltip="Assessment"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw; width: 100%;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all; 
            font-size: 2vw;" aria-hidden="false" aria-label="launch icon" [inline]="true">
              assessment
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">arrow_right</mat-icon>
            <div #menuTrigger2="matMenuTrigger" [matMenuTriggerFor]="reportsList"></div>
          </button>
          <mat-menu #reportsList="matMenu" [hasBackdrop]="false">
            <span (mouseleave)="menuTrigger2.closeMenu()">
              <button mat-menu-item style="font-size: 0.8vw;" *ngFor="let  listitem of reportsViewList"
                (click)="Navigate(listitem.rl,false);"> {{listitem.name | uppercase}}</button>
            </span>
          </mat-menu>
        </ng-container>

        <ng-container *ngIf="resourceRole != 'contractor' && resourceRole != 'distributor' 
        && this.userRole != 'CLIENT' && this.userRole != 'UTILRO'">
          <button mat-button (mouseenter)="matSelectClick('fourth')" matTooltip="Build"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw;width: 100%;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all; 
          font-size: 2vw;" aria-hidden="false" aria-label="launch icon" [inline]="true">
              build
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">arrow_right</mat-icon>
            <div #menuTrigger3="matMenuTrigger" [matMenuTriggerFor]="setupList"></div>
          </button>

          <mat-menu #setupList="matMenu" [hasBackdrop]="false">
            <span (mouseleave)="menuTrigger3.closeMenu()">
              <button mat-menu-item style="font-size: 0.8vw;" (click)="Navigate(linkObject.rl, linkObject?.ifDataLoad)"
                *ngFor="let linkObject of setupViewList">
                {{ linkObject.name | uppercase }}
              </button>
            </span>
          </mat-menu>
        </ng-container>


        <ng-container *ngIf="resourceRole != 'contractor' && resourceRole != 'distributor' 
          && this.userRole != 'CLIENT' && this.userRole != 'UTILRO'">
          <button mat-button (mouseenter)="matSelectClick('fifth')"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw;width: 100%;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all; 
            font-size: 2vw;" aria-hidden="false" aria-label="launch icon" matTooltip="Help Outline" [inline]="true">
              help_outline
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">arrow_right</mat-icon>
            <div #menuTrigger4="matMenuTrigger" [matMenuTriggerFor]="helpList"></div>
          </button>

          <mat-menu #helpList="matMenu" [hasBackdrop]="false">
            <span (mouseleave)="menuTrigger4.closeMenu()">
              <button mat-menu-item style="font-size: 0.8vw;">
                <ng-container *ngIf="!setupdata?.IsDynamicMenu">HELP</ng-container>
                <span *ngIf="setupdata?.IsDynamicMenu">
                  <ng-container *ngFor="let helpItem of setupHelpList">{{helpItem.name | uppercase}}</ng-container>
                </span>
              </button>
            </span>
          </mat-menu>
        </ng-container>


        <ng-container *ngIf="resourceRole == 'contractor' && userService.orgCd != null">
          <button mat-button (mouseenter)="matSelectClick('eight')"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw;width: 100%;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all; font-size: 2vw;" aria-hidden="false"
              aria-label="launch icon" matTooltip="Search" [inline]="true">
              access_time
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">arrow_right</mat-icon>
            <div #menuTrigger7="matMenuTrigger" [matMenuTriggerFor]="searchListMenu"></div>
          </button>

          <mat-menu #searchListMenu="matMenu" [hasBackdrop]="false">
            <span (mouseleave)="menuTrigger7.closeMenu()">
              <button mat-menu-item style="font-size: 0.8vw;" *ngFor="let  listitem of searchList"
                (click)="Navigate(listitem.rl,listitem?.ifDataLoad);"> {{listitem.name | uppercase}}</button>
            </span>
          </mat-menu>
        </ng-container>

        <ng-container *ngIf="setupDashboardList.length > 0 && userService.orgCd != null">
          <button mat-button (mouseenter)="matSelectClick('seven')"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw;width: 100%;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all; font-size: 2vw;" aria-hidden="false"
              aria-label="launch icon" matTooltip="Dashboard" [inline]="true">
              dashboard
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">arrow_right</mat-icon>
            <div #menuTrigger6="matMenuTrigger" [matMenuTriggerFor]="dashboardList"></div>
          </button>

          <mat-menu #dashboardList="matMenu" [hasBackdrop]="false">
            <span (mouseleave)="menuTrigger6.closeMenu()">
              <button mat-menu-item style="font-size: 0.8vw;" *ngFor="let  listitem of setupDashboardList"
                (click)="Navigate(listitem.rl,listitem?.ifDataLoad);"> {{listitem.name | uppercase}}</button>
            </span>
          </mat-menu>
        </ng-container>

        <ng-container *ngIf="(importExportMenu | json) != '{}' && importExportMenu != 0">
          <button mat-button (mouseenter)="matSelectClick('sixth')"
            style="font-size:0.5vw;color: whitesmoke;margin-right: 2vw;width: 100%;">
            <mat-icon style=" margin-right: 0.5vw !important; pointer-events:all; 
          font-size: 2vw;" aria-hidden="false" aria-label="launch icon" matTooltip="Import/Export" [inline]="true">
              import_export
            </mat-icon>
            <mat-icon style="font-size:2vw" [inline]="true">
              arrow_right</mat-icon>
            <div #menuTrigger5="matMenuTrigger" [matMenuTriggerFor]="main_menu"></div>
          </button>

          <mat-menu #main_menu="matMenu" [hasBackdrop]="false">
            <ng-container *ngFor="let mainItem of objectKeys(importExportMenu)">
              <button mat-menu-item style="font-size: 0.8vw;" [matMenuTriggerFor]="sub_menu">{{ mainItem | uppercase
                }}</button>
              <mat-menu #sub_menu="matMenu" [hasBackdrop]="false">
                <button *ngFor="let subItem of importExportMenu[mainItem]" style="font-size: 0.8vw;" mat-menu-item
                  (click)="subMenuImportExportClick(subItem);">{{ subItem | uppercase }}</button>
              </mat-menu>
            </ng-container>
          </mat-menu>
        </ng-container>
      </div>
    </mat-drawer>

    <mat-drawer-content (mouseenter)="matSelectClick(null)">

      <div *ngIf="loadHome" class="app-spinner">
        <mat-spinner [diameter]="80" color="primary"></mat-spinner>
      </div>

      <div class="app-body" *ngIf="utilList">
        <router-outlet></router-outlet>
      </div>

      <div class="app-footer">
        <app-footer [year]="year" [versionNum]="versionNum"></app-footer>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>